import peopleSearch from './people/peopleSearch';
import peopleProfile from './people/peopleProfile';
import group from './people/group';
import team from './team/team';
import navigation from './navigation/navigation';
import favorite from './favorite/favorite';
import stack from './stack/stack/stack';
import stackFilter from './stack/stackFilter/stackFilter';
import user from './user/user';
import search from './search/search';
import environment from './environment/environment';
import channel from './buzz/channel/channel';
import message from './buzz/message/message';
import property from './buzz/property/property';
import attachment from './buzz/attachment/attachment';
import buzzNavigation from './buzz/navigation/navigation';
import document from './document/document';
import card from './card/card';
import feature from './feature/feature';
import guide from './guide/guide';
import invite from './invite/invite';
import {default as homeNavigation} from './home/navigation/navigation';
import trend from './home/trend/trend';
import preference from './preference/preference';
import {combineReducers} from 'redux';
import dataSource from './dataSource/dataSource';
import cardFilter from './cardFilter/cardFilter';
import cardSetting from './cardSetting/cardSetting';
import chart from './chart/chart';
import view from './view/view';
import theme from './theme/theme';
import viewport from './viewport/viewport';
import poll from './poll/poll';
import cardDetail from './cardDetail/cardDetail';
import share from './share/share';
import bib from './bib/bib';
import cardExport from './cardExport/cardExport';
import notificationSetting from './notificationSetting/notificationSetting';
import layoutFrame from './layoutFrame/layoutFrame';

export default combineReducers({
  people: combineReducers({
    peopleSearch,
    peopleProfile,
    group,
  }),
  team,
  navigation,
  stack: combineReducers({
    stack,
    stackFilter,
  }),
  favorite,
  user,
  environment,
  search,
  buzz: combineReducers({
    channel,
    message,
    property,
    attachment,
    navigation: buzzNavigation,
  }),
  card,
  chart,
  document,
  feature,
  guide,
  invite,
  home: combineReducers({
    navigation: homeNavigation,
    trend,
  }),
  preference,
  dataSource,
  cardFilter,
  view,
  theme,
  cardSetting,
  viewport,
  poll,
  cardDetail,
  share,
  bib,
  cardExport,
  notificationSetting,
  layoutFrame,
});
